
import { AuthMixin } from '@/mixins/AuthMixin';
import { WeddingEventImageCaptionSettings } from '@/types/wedding';
import { mixins } from 'vue-class-component';
import { Component, Prop, Emit } from 'vue-property-decorator';

@Component({
  name: 'wedding-event-image-caption-form',
})
export default class WeddingEventImageCaptionForm extends mixins(AuthMixin) {
  @Prop({ required: true, type: Object, default: () => ({ title: '' }) })
  readonly value!: WeddingEventImageCaptionSettings;

  get captionData(): WeddingEventImageCaptionSettings {
    return this.value;
  }

  get isValid(): boolean {
    return !!this.captionData.title;
  }

  onInput(key: keyof WeddingEventImageCaptionSettings, value: string) {
    const updatedValue = { ...this.captionData };
    updatedValue[key] = value;
    this.$emit('input', updatedValue);
  }

  @Emit('submit')
  submitCaption() {
    return this.captionData;
  }
}
